import React, { useState, useMemo } from 'react';
import EventReporter from 'appEvents';
import { AppEvents, EventProviders } from 'constants/events';
import { KSelect, Button } from 'lego-dist';
import {
  LabelSection,
  LabelTitle,
  ModalDescription,
  SelectExportCentersContainer,
  ButtonGroup,
  SelecterContainer,
} from './styles/SelectExportCenters';
import useCenters from 'hooks/centers/UseCenters';
import CenterService from 'services/CenterService';
import { useCookies } from 'react-cookie';

interface SelectExportCentersProps {
  multipleCenters: boolean;
  selectedCenter: any;
  t: (section: string) => string;
  user: any;
  onRequestData: (bool: boolean) => void;
  onCloseModal: (bool: boolean) => void;
}

const centerService = CenterService.getInstance();

const SelectExportCentersView: React.FC<SelectExportCentersProps> = ({
  user, multipleCenters, t, onRequestData, onCloseModal, selectedCenter,
}) => {
  const [centers, setCenters] = useState<any[]>([]);
  const { centerList } = useCenters();
  const [, setCookie] = useCookies(['kinedu-export-data-cookie']);

  const setExportDataCookie = () => setCookie(
    'kinedu-export-data-cookie',
    '1',
    { path: '/', expires: new Date(Date.now() + 1000 * 60 * 60 * 24) },
  );

  const registerExportDataAction = () => {
    EventReporter.action(AppEvents.DATA_EXPORTED({}), [EventProviders.MIXPANEL]);
  };

  const requestCentersData = async () => {
    try {
      const params = {
        operation_record: {
          requester: user.fullname,
          requester_email: user.email,
          requester_id: user.id,
          center_ids: centers,
        },
      };
      await centerService.requestCentersData(params);
      setExportDataCookie();
      registerExportDataAction();
      onRequestData(true);
    } catch (error) {
      console.log('error: ', error);
    }
  };

  const isDisabled = useMemo(() => !centers.length, [centers]);
  useMemo(() => selectedCenter ? setCenters([selectedCenter]) : null, [selectedCenter]);

  const buttonColors = useMemo(() => isDisabled ? '#8295A3' : 'var(--cognitive-green)', [isDisabled]);
  const title = t(`settings:EXPORT_DATA.MODAL.${multipleCenters ? 'MULTIPLE_CENTERS_TITLE' : 'SINGLE_CENTER_TITLE'}`);
  const initialDescription = t('settings:EXPORT_DATA.MODAL.DESCRIPTION_PART_ONE');
  const finalDescription = t('settings:EXPORT_DATA.MODAL.DESCRIPTION_PART_TWO');
  const subtitle = t('settings:EXPORT_DATA.MODAL.SUBTITLE');
  const UserEmail = () => (<b>{user.email}</b>);

  const ModalText = (
    <>
      <LabelTitle>{title}</LabelTitle>
      <ModalDescription>
        {initialDescription}
        <UserEmail />
        {finalDescription}
      </ModalDescription>
    </>
  );

  const ActionButtons = (
    <ButtonGroup>
      <Button
        color="#8295A3"
        outline
        rounded
        onClick={() => onCloseModal(false)}
      >
        {t('settings:EXPORT_DATA.MODAL.CANCEL')}
      </Button>
      <Button
        disabled={isDisabled}
        color={buttonColors}
        flat
        rounded
        onClick={requestCentersData}
      >
        {t('settings:EXPORT_DATA.MODAL.SUBMIT')}
      </Button>

    </ButtonGroup>
  );

  const onSelect = (ev: any) => {
    setCenters(ev.value);
  };

  return (
    <>
      <SelectExportCentersContainer>
        {ModalText}
        {
          multipleCenters ? (
            <>
              <LabelSection>{subtitle}</LabelSection>
              <SelecterContainer>
                <KSelect
                  multiple
                  data={centerList}
                  filter
                  onSelect={onSelect}
                  value={centers}
                  placeholder={t('settings:EXPORT_DATA.MODAL.SELECT_CENTERS_HINT')}

                />
              </SelecterContainer>
            </>
          ) : null
        }
        {ActionButtons}
      </SelectExportCentersContainer>
    </>
  );
};
export default SelectExportCentersView;
